export const EMAIL_REGEX = /^[^^ñÑ\s@]+@[^\s@]+\.[^\s@]+$/ // it does not admit white spaces or ñ
export const TEXT_REGEX = /^[a-zA-ZáÁéÉíÍóÓúÚñÑ0-9\s.,-]+$/;
export const ONLY_LETTERS_REGEX = /^[a-zA-ZáÁéÉíÍóÓúÚñÑ\s]+$/
export const ONLY_LETTERS_AND_NUMBERS_REGEX = /^[ a-zA-Z0-9]+$/
export const PASSPORT_REGEX = /^[A-Z]{3}\d{6}[A-Z]?$/i
export const PHONE_REGEX = /^[679]\d{8}$/
export const POSTCODE_REGEX = /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/